<template>
  <div class="slide_up">
    <div class="drag_indicator"></div>

    <slot></slot>
  </div>
</template>

<script>
export default {
  props: [
  ],
}
</script>


<style scoped>
.slide_up {
  -webkit-overflow-scrolling: touch;
  background-color: #fff;
  border-radius: 16px 16px 0 0;
  bottom: 0;
  max-height: calc(100vh - 20px - 8px - env(safe-area-inset-bottom) - env(safe-area-inset-top));
  left: 0;
  /*overflow-y: scroll;*/
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: 1rem;
  padding-right: 1rem;
  position: fixed;
  right: 0 ;
  z-index: 1210;
}
.drag_indicator {
  height: 0;
}
.drag_indicator:after {
  background-color: #ccc;
  border-radius: 3px;
  content: "";
  display: block;
  height: 6px;
  left: calc(50% - 1.5rem);
  margin-top: 0.375rem;
  position: absolute;
  top: 0;
  width: 3rem;
}
</style>
